module.exports = __webpack_public_path__ + "img/featured-vehicle-row-23-lincoln.d4cdcc49.jpg";